<template>
<!-- 登录 -->
  <div class="login_back">
    <div style="height: 100vh;">
      <img src="../../assets/login.jpg" style="width: 100vw;height: 100vh;">
    </div>
    <div class="login_div">
      <h3>武汉市悠然智在科技有限责任公司</h3>
      <el-form :model="loginParams" status-icon :rules="rules" ref="loginParams">
        <el-form-item prop="account" style="margin-bottom:35px">
          <el-input v-model="loginParams.account" placeholder="账号" autocomplete="off" maxlength="20" show-word-limit></el-input>
        </el-form-item>
        <el-form-item prop="password" style="margin-bottom:35px">
          <el-input show-password v-model="loginParams.password" placeholder="密码" autocomplete="off" maxlength="20"></el-input>
        </el-form-item>
        <el-form-item style="text-align: center">
          <el-button type="primary" @click="subMit('loginParams')">立即登录</el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      loginParams: {
        account: "",
        password: ""
      },
      rules: {
        account: [{ required: true, message: "请输入用户名", trigger: "blur" }],
        password: [{ required: true, message: "请输入密码", trigger: "blur" }],
      },
    };
  },
  methods: {
    subMit(formName){
      this.$refs[formName].validate((valid) => {
        if (!valid) {
          return false;
        } else {
          this.axios({
            method: "post",
            url: "/y-user-info/login",
            data: this.loginParams,
          }).then((res) => {
            if (res.data.code === 200) {
              localStorage.setItem("userId", res.data.data.id);
              sessionStorage.setItem("defaultActive","/admin/homePage")
              this.$router.push("/admin/homePage");
            } else {
              this.$message({
                type: "error",
                message: res.data.message,
              });
            }
          });
        }
      });
    },
  },
};
</script>

<style>
.login_div {
  width: 300px;
  background-color: #ffffff;
  margin: 280px auto;
  padding: 15px 35px 10px 35px;
  border-radius: 10px;
  position: absolute;
  top: -50px;
  right: 300px;
}
.login_back {
  background-color: white;
  width: 100vw;
  height: 100vh;
  overflow: hidden;
}

h3 {
  text-align: center;
  margin-bottom: 30px;
}
</style>
